<template>
  <div class="tracking-wide text-xs text-center py-2 bg-primary-dark text-white opacity-25">
    <span>{{ name }}</span>
    <small class="text-xs ml-2">{{ version }}</small>
  </div>
</template>

<script>
export default {
  computed: {
    name() {
      return this.$store.getters['app/name']
    },
    version() {
      return this.$store.getters['app/version']
    },
  },
}
</script>
